export const actionType = {
    ADD_MOVIE_TO_WATCHLIST: 'ADD_MOVIE_TO_WATCHLIST',
    ADD_MOVIE_TO_WATCHED: 'ADD_MOVIE_TO_WATCHED',
    REMOVE_MOVIE_FROM_WATCHLIST: 'REMOVE_MOVIE_FROM_WATCHLIST',
    REMOVE_MOVIE_FROM_WATCHED: 'REMOVE_MOVIE_FROM_WATCHED',
    MOVE_TO_WATCHLIST: 'MOVE_TO_WATCHLIST',
}